module.exports = __webpack_public_path__ + "media/images/ui__arrowUpInactive--dark-19a20c87debc6f751039b7976438153e.png";